// extracted by mini-css-extract-plugin
module.exports = {"assistents":"assistents_assistents__TAVnY","aplicacio":"assistents_aplicacio__UWaHz"};